import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Card, Dropdown, Grid, Header, Dimmer, Loader, Feed, Icon } from 'semantic-ui-react';

import EventSearchInput from './other-elements/event-search-input';
import LoadingMoreIndicator from './other-elements/loading-more-indicator';
import EventCardItem from './event-card-item';

import {
  EVENT_TYPES,
} from './../../hocs/data/with-dyzio-events-data';

const containerCardStyles = {
  minHeight: 208,
  maxHeight: 708,
  width: '100%',
  overflowY: 'auto',
};

const emptyStateStyle = {
  marginTop: 25,
};

const EmptyState = () => (
  <Header icon style={emptyStateStyle}>
    <Icon name="wait outline" />
    No events yet
  </Header>
);

const eventTypes = [
  {
    key: EVENT_TYPES.ALL,
    text: 'all events',
    value: EVENT_TYPES.ALL,
  },
  {
    key: EVENT_TYPES.USER_CREATED,
    text: 'user added',
    value: EVENT_TYPES.USER_CREATED,
  },
  {
    key: EVENT_TYPES.SHORTLIST_CREATED,
    text: 'shortlist created',
    value: EVENT_TYPES.SHORTLIST_CREATED,
  },
  {
    key: EVENT_TYPES.INFLUENCER_CREATED,
    text: 'influencer added',
    value: EVENT_TYPES.INFLUENCER_CREATED,
  },
  {
    key: EVENT_TYPES.CAMPAIGN_CREATED,
    text: 'campaign created',
    value: EVENT_TYPES.CAMPAIGN_CREATED,
  },
];

const descriptionStyle = { color: 'rgba(0,0,0,.4)' };
const filtersGridStyle = { paddingLeft: 10, paddingRight: 10, paddingBottom: 10 };

export default function FeedTypeCards({
  title,
  isCompact,
  shouldRenderFilters,
  description,
  cardColour,
  onEventTypeFilterChanged,
  onSearch,
  events,
  onClearSearch,
  eventTypeFilter,
  canLoadMore,
  isLoadingMore,
  onFeedBodyScroll,
  noEvents,
  isLoading,
}) {
  return (
    <Card fluid color={cardColour}>
      {
        !isCompact &&
        <Card.Content>
          <div>
            <h2>{ title }</h2>
            <p style={descriptionStyle}>
              { description }
            </p>
          </div>
        </Card.Content>
      }
      {
        shouldRenderFilters &&
        <Grid columns="two" style={filtersGridStyle}>
          <Grid.Row>
            <Grid.Column>
              <EventSearchInput
                onSearch={onSearch}
                onClearSearch={onClearSearch}
              />
            </Grid.Column>
            <Grid.Column>
              <Dropdown
                onChange={onEventTypeFilterChanged}
                placeholder="Event type"
                options={eventTypes}
                selection
                fluid
                value={eventTypeFilter}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      }
      <Card.Content
        style={containerCardStyles} onScroll={e => {
          onFeedBodyScroll({
            scrollHeight: e.target.scrollHeight,
            scrollTop: e.target.scrollTop,
            clientHeight: e.target.clientHeight,
          });
        }}
      >
        {
          isLoading &&
            <Dimmer active inverted>
              <Loader>Loading events...</Loader>
            </Dimmer>
        }
        {
          noEvents && !isLoading && <EmptyState />
        }
        {
          !isLoading && !noEvents &&
            <Feed>
              { _.map(events, event => <EventCardItem key={event.id} {...event} isCompact={isCompact} />) }
            </Feed>
        }
      </Card.Content>
      <LoadingMoreIndicator
        canLoadMore={canLoadMore}
        isLoadingMore={isLoadingMore}
        shownEventsCount={_.size(events)}
      />
    </Card>
  );
}

FeedTypeCards.propTypes = {
  isCompact: PropTypes.bool,
  shouldRenderFilters: PropTypes.bool,
  onEventTypeFilterChanged: PropTypes.func.isRequired,
  onSearch: PropTypes.func.isRequired,
  onClearSearch: PropTypes.func.isRequired,
  eventTypeFilter: PropTypes.oneOf([
    ...EVENT_TYPES,
  ]).isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  cardColour: PropTypes.string.isRequired,
  events: PropTypes.array.isRequired,
  canLoadMore: PropTypes.bool.isRequired,
  isLoadingMore: PropTypes.bool.isRequired,
  onFeedBodyScroll: PropTypes.func.isRequired,
  noEvents: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

FeedTypeCards.defaultProps = {
  isCompact: true,
  shouldRenderFilters: false,
};



/** WEBPACK FOOTER **
 ** ./src/containers/event-feed/feed-type-cards.js
 **/